import * as yup from 'yup';

const faxFormat = /^\+44\s?(\d{10}|\d{2} (\d{8}|\d{4} \d{4})|\d{3} (\d{7}|\d{3} \d{4}|\d{2} \d{5})|\d{4} \d{6})$/;

export const Schema = (surgery = {}) => {
  const {
    surgery_name: name, surgery_fax, surgery_email, integration_method,
    address_1, address_2, address_3, address_4, address_5,
    odsCode, branchCode, postcode, note, contactNumber
  } = surgery;
  
  const emailValidation = () => {
    return (integration_method === 'email')
    ? yup.string().trim().email().required('Required - GP Integration Method is set to "Email"')
    : yup.string().trim().email();
  };
  
  const faxValidation = () => {
    const message ='this must be a valid fax number eg: +441223123123';
    return (integration_method === 'fax')
      ? yup.string().trim().required('Required - GP Integration Method is set to "Fax"').matches(faxFormat, message)
      : yup.string().trim().matches(faxFormat, { message, excludeEmptyString: true })
  };

  return {
    name: {
      'Name': { fieldName: 'surgery_name', value: name, field: 'surgery_name', validation: yup.string().required() },
    },
    address: {
      'Postcode': { fieldName: 'postcode', value: postcode, field: 'address.postcode', validation: yup.string().required(), },
      'Address 1': { fieldName: 'address_1', value: address_1, field: 'address.address_1', validation: yup.string().required(), },
      'Address 2': { fieldName: 'address_2', value: address_2, field: 'address.address_2', validation: yup.string().optional(), },
      'Address 3': { fieldName: 'address_3', value: address_3, field: 'address.address_3', validation: yup.string().optional(), },
      'Address 4': { fieldName: 'address_4', value: address_4, field: 'address.address_4', validation: yup.string().optional(), },
      'Address 5': { fieldName: 'address_5', value: address_5, field: 'address.address_5', validation: yup.string().optional(), },
      'Contact Number': { fieldName: 'contactNumber', value: contactNumber, field: 'contactNumber', validation: yup.string().optional(), },
    },
    odsCode: {
      'ODS Code': { fieldName: 'odsCode', value: odsCode, field: 'odsCode.odsCode', validation: yup.string().required(), },
      'Branch Code': { fieldName: 'branchCode', value: branchCode, field: 'odsCode.branchCode', validation: yup.string().required(), },
    },
    note: {
      'Notes': { fieldName: 'note', defaultValue: note, field: 'note', validation: yup.string().optional() },
    },
    integration: {
      'Email': { fieldName: 'surgery_email', defaultValue: surgery_email, field: 'surgery_email', validation: emailValidation() },
      'Fax': { fieldName: 'surgery_fax', defaultValue: surgery_fax, field: 'surgery_fax', validation: faxValidation() },
    },
  }
}
